import { render, staticRenderFns } from "./InvocationMessage.vue?vue&type=template&id=2d0b091a"
import script from "./InvocationMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvocationMessage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports